import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=22487934&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"
import style0 from "./Customer.vue?vue&type=style&index=0&id=22487934&prod&scoped=true&lang=css"
import style1 from "./Customer.vue?vue&type=style&index=1&id=22487934&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22487934",
  null
  
)

export default component.exports